module.exports = __webpack_public_path__ + "img/12_klio_13.4a32d70e.jpg";